import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-catalog-404-container',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<h2>Catalog 404</h2>'
})
export class Catalog404Container {}
